import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
The main entry point for the Store.

Referenced by the page.store.liquid template.
* */
import ReactDOM from 'react-dom';
import { Provider } from 'urql';
import graphqlClient from './utils/graphqlClient';
import Store from './components/Shop';
import { jsx as _jsx } from "react/jsx-runtime";

function init() {
  var PAGE_ID = window.OV.PAGE_ID;
  var search = window.location.search; // eslint-disable-line

  var urlParams = new URLSearchParams(search);
  var client = graphqlClient(urlParams);
  var rootEl = document.getElementById('store');
  var props = {
    shopifyId: PAGE_ID,
    loadingHTML: rootEl.innerHTML
  };
  ReactDOM.render( /*#__PURE__*/_jsx(Provider, {
    value: client,
    children: /*#__PURE__*/_jsx(Store, _objectSpread({}, props))
  }), document.getElementById('store'));
}

init();